<!--
    Styles
-->

<style>


    /* main */

    .ui-image {
        position: relative;
        overflow: hidden;
        background-image: linear-gradient(45deg , var(--cl-gray-light), var(--cl-gray), var(--cl-gray-light), var(--cl-gray), var(--cl-gray-light));
        background-size: 1000px 1000px;
        animation: ui-image 1s linear infinite;
    }


    /* item */

    .ui-image .item {
        opacity: 0;
        align-items: center;
        background: var(--cl-gray-light);
    }
    .ui-image .item.active {
        opacity: 1;
        transition: opacity 0.3s ease;
    }
    .ui-image .item svg {
        width: 28px;
        height: 28px;
        fill: var(--cl-gray);
    }


    /* animation */

    @keyframes ui-image {
        0%   {background-position: 0 0;}
        100% {background-position: -1000px 0;}
    }


</style>



<!--
    Template
-->

<template>
    <div class="ui-image">
        <div class="item u-cover u-col" :class="{active: success}">
            <img :src="src" @load="success = true" @error="error = true">
        </div>
        <div class="item u-cover u-col" :class="{active: error}">
            <icon-image />
        </div>
    </div>
</template>



<!--
    Scripts
-->

<script>


    import iconImage from '@/assets/icons/image.svg'


    export default {

        components: {
            iconImage
        },

        inheritAttrs: false,

        props: [
            'src'
        ],

        data () {
            return {
                error: false,
                success: false
            }
        },

        watch: {

            src () {
                this.error = false;
                this.success = false
            }

        }

    }

</script>

